/***
 * @Author: ZhaoG
 * @Date: 2025-04-29 08:27:30
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-06 16:01:28
 * @FilePath: \gcp-fe\src\app\procurementNotice\js\formOptions.js
 * @Description: 搜索条件配置
 */

import Cookies from "js-cookie";

const $t = key =>
  typeof window !== "undefined" && window.$t ? window.$t(key) : key;

export default function createFormOptions() {
  return {
    // 公告类型
    typeOptions: [
      { value: 1, label: $t("page.content.openProcurementAnnouncement") },
      {
        value: 2,
        label: $t("page.content.invitationProcurementAnnouncement"),
        isNotLogin: Cookies.get("access_token") ? "2" : "1"
      },
      {
        value: 3,
        label: $t("page.content.bidReviewResultPublicity"),
        isNotLogin: "2"
      },
      {
        value: 4,
        label: $t("page.content.biddingResultPublicity"),
        isNotLogin: "2"
      },
      { value: 5, label: $t("page.content.bidNotification"), isNotLogin: "2" },
      {
        value: 6,
        label: $t("page.content.supplementaryAnnouncement"),
        isNotLogin: "2"
      },
      { value: 7, label: $t("page.content.flowAnnouncement"), isNotLogin: "2" },
      { value: 8, label: $t("page.content.businessAnnouncement") }
    ],
    // 采购方式
    methodOptions: [
      { value: "0", label: $t("page.content.all"), isShow: true },
      { value: "1", label: $t("page.content.publicBidding"), isShow: true },
      { value: "2", label: $t("page.content.invitationTender"), isShow: false },
      {
        value: "3",
        label: $t("page.content.inquiryCompareShort"),
        isShow: true,
        option: [
          {
            label: $t("page.content.publicInquiryCompare"),
            value: "3002",
            isDisabled: false
          },
          {
            label: $t("page.content.invitationInquiryCompare"),
            value: "3001",
            isNotLogin: Cookies.get("access_token") ? "2" : "1",
            isDisabled: true
          }
        ]
      },
      {
        value: "4",
        label: $t("page.content.negotiationShort"),
        isShow: true,
        option: [
          {
            label: $t("page.content.publicNegotiation"),
            value: "4002",
            isDisabled: false
          },
          {
            label: $t("page.content.invitationNegotiation"),
            value: "4001",
            isNotLogin: Cookies.get("access_token") ? "2" : "1",
            isDisabled: true
          }
        ]
      },
      {
        value: "5",
        label: $t("page.content.auctionShort"),
        isShow: true,
        option: [
          {
            label: $t("page.content.publicOutcry"),
            value: "5002",
            isDisabled: false
          },
          {
            label: $t("page.content.inviteBidd"),
            value: "5001",
            isNotLogin: Cookies.get("access_token") ? "2" : "1",
            isDisabled: true
          },
          {
            label: $t("page.content.wasteMaterials"),
            value: "5003",
            isDisabled: false
          }
        ]
      },
      {
        value: "6",
        label: $t("page.content.otherProcurementAlt"),
        isShow: true,
        option: [
          { label: $t("page.content.openSingleSource"), value: "6001" },
          { label: $t("page.content.offlinePublicBidding"), value: "6002" },
          { label: $t("page.content.offlinePublicInquiry"), value: "6003" },
          { label: $t("page.content.openCollaboration"), value: "6004" }
        ]
      }
    ],

    timeOptions: [
      { value: 0, label: $t("page.content.all") },
      { value: 3, label: $t("page.content.nearly3Days") },
      { value: 7, label: $t("page.content.nearly7Days") },
      { value: 30, label: $t("page.content.nearly30Days") }
    ],

    statusOptions: [
      { value: "", label: $t("page.content.all") },
      { value: 0, label: $t("page.content.signingUp") },
      { value: 1, label: $t("page.content.Ended") }
    ],
    statusOptions0: [
      { value: "", label: $t("page.content.all") },
      { value: 0, label: $t("page.content.Publiclyannounced") },
      { value: 1, label: $t("page.content.Ended") }
    ],
    wuziOptions: [
      {
        value: "1",
        label: $t("page.content.landConstructionEquipment"),
        list: [
          {
            value: "1 - 1",
            label: $t("page.content.landConstructionEquipment")
          }
        ]
      },

      {
        value: "2",
        label: $t("page.content.waterConstructionEquipment"),
        list: [
          {
            value: "2 - 1",
            label: $t("page.content.waterConstructionEquipment")
          }
        ]
      },
      {
        value: "3",
        label: $t("page.content.otherEquipment"),
        list: [
          {
            value: "14 - 1",
            label: $t("page.content.otherEquipment")
          }
        ]
      }
    ],
    categoryOptions: [
      // { value: 0, label: $t('page.content.all') },
      { value: 1, label: $t("page.content.portNavigation"), data: [] },
      { value: 2, label: $t("page.content.dredging"), data: [] },
      { value: 3, label: $t("page.content.highway"), data: [] },
      { value: 4, label: $t("page.content.bridge"), data: [] },
      { value: 5, label: $t("page.content.tunnel"), data: [] },
      { value: 6, label: $t("page.content.railTransit"), data: [] },
      { value: 7, label: $t("page.content.housingConstruction"), data: [] },
      {
        value: 8,
        label: $t("page.content.municipalPublicUtilities"),
        data: []
      },
      { value: 9, label: $t("page.content.airport"), data: [] },
      { value: 10, label: $t("page.content.mechanicalElectrical"), data: [] },
      {
        value: 11,
        label: $t("page.content.waterConservancyHydropower"),
        data: []
      },
      { value: 12, label: $t("page.content.ecologicalEnvironment"), data: [] },
      { value: 13, label: $t("page.content.greenEnergy"), data: [] },
      { value: 14, label: $t("page.content.otherBusiness"), data: [] }
    ],
    categoryOptions0: [
      {
        value: "1",
        label: $t("page.content.highway"),
        list: [
          {
            value: "1 - 1",
            label: $t("page.content.highway")
          }
        ]
      },
      {
        value: "2",
        label: $t("page.content.bridge"),
        list: [
          {
            value: "2 - 1",
            label: $t("page.content.bridge")
          }
        ]
      },
      {
        value: "3",
        label: $t("page.content.tunnel"),
        list: [
          {
            value: "3 - 1",
            label: $t("page.content.tunnel")
          }
        ]
      },
      {
        value: "4",
        label: $t("page.content.portNavigation"),
        list: [
          {
            value: "4 - 1",
            label: $t("page.content.portNavigation")
          }
        ]
      },
      {
        value: "5",
        label: $t("page.content.dredging"),
        list: [
          {
            value: "5 - 1",
            label: $t("page.content.dredging")
          }
        ]
      },
      {
        value: "6",
        label: $t("page.content.railTransit"),
        list: [
          {
            value: "6 - 1",
            label: $t("page.content.railTransit")
          }
        ]
      },

      {
        value: "8",
        label: $t("page.content.municipalUtilities"),
        list: [
          {
            value: "8 - 1",
            label: $t("page.content.municipalUtilities")
          }
        ]
      },
      {
        value: "9",
        label: $t("page.content.airport"),
        list: [
          {
            value: "9 - 1",
            label: $t("page.content.airport")
          }
        ]
      },
      {
        value: "10",
        label: $t("page.content.mechanicalElectrical"),
        list: [
          {
            value: "10 - 1",
            label: $t("page.content.mechanicalElectrical")
          }
        ]
      },
      {
        value: "11",
        label: $t("page.content.waterConservancyHydropower"),
        list: [
          {
            value: "11 - 1",
            label: $t("page.content.waterConservancyHydropower")
          }
        ]
      },
      {
        value: "12",
        label: $t("page.content.ecologicalEnvironment"),
        list: [
          {
            value: "12 - 1",
            label: $t("page.content.ecologicalEnvironment")
          }
        ]
      },
      {
        value: "13",
        label: $t("page.content.greenIntegration"),
        list: [
          {
            value: "13 - 1",
            label: $t("page.content.greenIntegration")
          }
        ]
      },
      {
        value: "14",
        label: $t("page.content.housing"),
        list: [
          {
            value: "14 - 1",
            label: $t("page.content.housing")
          }
        ]
      }
    ],
    goodsOptions: [
      {
        value: "1",
        label: $t("page.content.steel"),
        isShow: false
      },
      {
        value: "2",
        label: $t("page.content.cementProducts"),
        isShow: false
      },
      {
        value: "3",
        label: $t("page.content.asphaltProducts"),
        isShow: false
      },
      {
        value: "4",
        label: $t("page.content.fuelLubricants"),
        isShow: false
      },
      {
        value: "5",
        label: $t("page.content.landConstructionEquipment"),
        isShow: false
      },
      {
        value: "6",
        label: $t("page.content.waterConstructionEquipment"),
        isShow: false
      },

      {
        value: "8",
        label: $t("page.content.otherMetalMaterials"),
        isShow: false
      },
      {
        value: "9",
        label: $t("page.content.woodBambooProducts"),
        isShow: false
      },
      {
        value: "10",
        label: $t("page.content.chemicalStandardElectrical"),
        isShow: false
      },
      {
        value: "11",
        label: $t("page.content.buildingDecorativeMaterials"),
        isShow: false
      },
      {
        value: "12",
        label: $t("page.content.specialToolsEquipment"),
        isShow: false
      },
      {
        value: "13",
        label: $t("page.content.assetServiceCategory"),
        isShow: false
      },
      {
        value: "14",
        label: $t("page.content.otherTypes"),
        isShow: false
      }
    ]
  };
}
